module.exports = __webpack_public_path__ + "img/back.f3764ea9.png";